import { base64ToArrayBuffer } from "./pdfUtils"

export const openPdf = (document: string): void => {
	const content = base64ToArrayBuffer(document)
	const file = new Blob([content], { type: "application/pdf" })
	const fileURL = URL.createObjectURL(file)
	window.open(fileURL)
}
